import React from 'react';

import { createArrayOfDate } from '@candu-ai/analytics/utils';

import { TimeChart } from '../TimeChart';

const MILLIS_IN_A_WEEK = 604800000;

export const NoDataChart = ({ syncId }: { syncId: string }) => {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const oneWeekAgo = today.getTime() - MILLIS_IN_A_WEEK;

  const emptyData = createArrayOfDate({
    timestamp: oneWeekAgo / 1000,
    upperTimestamp: today.getTime() / 1000,
  }).map((date) => ({
    date,
  }));

  return (
    <TimeChart syncId={syncId} legend="" entries={[]} chartData={emptyData} xAxisDataKey="date" />
  );
};
